// @flow

import Pusher from 'pusher-js'

class MessageConnector {
  constructor(pusherKey: string, dev?: boolean) {
    this.socket = new Pusher(pusherKey)
    this.channelName = ''
    if (dev) {
      Pusher.log = log => console.log(log)
    }
  }

  channelName: string
  socket: any
  channel: any

  subscribe(reservation: { id: number }, event: string, callback: Function) {
    if (this.channel) this.unsubscribe()
    this.channelName = `reservation-${reservation.id}`
    this.channel = this.socket.subscribe(this.channelName)
    this.channel.bind(event, callback)
  }

  unsubscribe() {
    if (this.socket) {
      this.socket.unsubscribe(this.channelName)
    }
    if (this.channel) {
      this.channel.unbind()
      this.channel = null
    }
  }
}

export default MessageConnector



// WEBPACK FOOTER //
// ./src/lib/message-connector.js